let islgdAddress = {
  personalCenterUrl:`${outUrlStr}/personalCenter/#`,
  api:`${outUrlStr}/`,
  iconUrl:`${outUrlStr}/data/pharmnews/icon/`
}
export {islgdAddress};



// WEBPACK FOOTER //
// ./src/common/config.js